/* APERIGUSTO_R5_20260802 */
(() => {
  'use strict';

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPanel = document.querySelector(
      'sorting-filter-component details[open], .facets__item details[open], .cc-parity-mobile-drawer[open]'
    );
    if (!openPanel) return;
    const summary = openPanel.querySelector(':scope > summary');
    openPanel.removeAttribute('open');
    summary?.setAttribute('aria-expanded', 'false');
    summary?.focus({ preventScroll: true });
  }, true);

  const preserveLocaleQuery = (root = document) => {
    root.querySelectorAll('[data-ap-language-link]').forEach((link) => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      target.search = window.location.search;
      link.href = target.pathname + target.search + target.hash;
    });
  };

  const initSubmenus = (root = document) => {
    root.querySelectorAll('.cc-parity-nav__submenu-toggle').forEach((button) => {
      if (button.dataset.apR5Bound === 'true') return;
      button.dataset.apR5Bound = 'true';
      const submenu = document.getElementById(button.getAttribute('aria-controls'));
      if (!submenu) return;
      const close = () => button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); button.focus(); }
      });
      submenu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); button.focus(); }
      });
      document.addEventListener('click', (event) => {
        if (!button.parentElement?.contains(event.target)) close();
      });
    });
  };

  const init = (root = document) => { preserveLocaleQuery(root); initSubmenus(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
